import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "flex-grow-1 min-w-0",
  id: "mainMenu"
}
const _hoisted_3 = { class: "d-flex flex-row align-items-end flex-column h-100" }
const _hoisted_4 = { class: "flex-grow-1 w-100 overflow-auto" }
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = {
  id: "footer",
  class: "bg-dark d-flex mt-auto"
}
const _hoisted_7 = { class: "my-2 mx-auto" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dot text-light" }, null, -1)
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu_2 = _resolveComponent("Menu_2")!
  const _component_Menu_1 = _resolveComponent("Menu_1")!
  const _component_ModuleContainer = _resolveComponent("ModuleContainer")!
  const _component_LegalNotice = _resolveComponent("LegalNotice")!
  const _component_PrivacyStatement = _resolveComponent("PrivacyStatement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "d-flex bg-white w-100 flex-grow-1 shadow z-index-1",
      style: _normalizeStyle({height: _ctx.config.general.container.config.headerHeightEm + 'em'})
    }, [
      (_ctx.config.general.container.config.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "h-100",
            src: _ctx.config.general.container.config.logo.itemSrc,
            style: {objectFit: 'contain', objectPosition: 'left'}
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.config.menus.items.find(i => i.position === 2))
            ? (_openBlock(), _createBlock(_component_Menu_2, {
                key: 0,
                class: "pb-0",
                "additional-items": _ctx.config.menus.items.find(i => i.position === 2).additionalItems
              }, null, 8, ["additional-items"]))
            : _createCommentVNode("", true),
          (_ctx.config.menus.items.find(i => i.position === 1))
            ? (_openBlock(), _createBlock(_component_Menu_1, {
                key: 1,
                class: "mt-auto pt-0",
                "additional-items": _ctx.config.menus.items.find(i => i.position === 1).additionalItems,
                pages: _ctx.config.pages
              }, null, 8, ["additional-items", "pages"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.siteType === _ctx.SiteType.Main)
          ? (_openBlock(), _createBlock(_component_ModuleContainer, {
              key: 0,
              pages: _ctx.config.pages,
              "offset-top": _ctx.config.general.container.config.headerHeight
            }, null, 8, ["pages", "offset-top"]))
          : _createCommentVNode("", true),
        (_ctx.siteType === _ctx.SiteType.LegalNotice)
          ? (_openBlock(), _createBlock(_component_LegalNotice, {
              key: 1,
              legal: _ctx.config.legal
            }, null, 8, ["legal"]))
          : _createCommentVNode("", true),
        (_ctx.siteType === _ctx.SiteType.PrivacyStatement)
          ? (_openBlock(), _createBlock(_component_PrivacyStatement, { key: 2 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            class: "text-light",
            href: _ctx.$t('sitemap.legalNotice')
          }, _toDisplayString(_ctx.$t( 'common.legalNotice' )), 9, _hoisted_8),
          _hoisted_9,
          _createElementVNode("a", {
            class: "text-light",
            href: _ctx.$t('sitemap.privacyStatement')
          }, _toDisplayString(_ctx.$t( 'common.privacyStatement' )), 9, _hoisted_10)
        ])
      ])
    ])
  ], 64))
}